
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquare } from "bootstrap-icons/icons/plus-square.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CheckCircleFill } from "bootstrap-icons/icons/check-circle-fill.svg";
import { ReactComponent as LightningChargeFill } from "bootstrap-icons/icons/lightning-charge-fill.svg";
import { ReactComponent as DeleteFlashIcon } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as EditFlashIcon } from "bootstrap-icons/icons/pencil.svg";
import { useState, useEffect, useContext } from "react";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
import { handleError } from "../../components/utils/AuthenticationCheck";
// import DropDownMenu from "../flashSales/dropdownForproductRow/DropDownMenu";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import formatDate from "../../components/utils/DateFormatter";
const PendingproductRowList = () => {
  const [productRowList, setproductRowList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);
  // console.log("this is permissions", permissions);
  const navigate = useNavigate();

  // Fetch product stock
  useEffect(() => {
    const fetchproductRowList = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }

        const response = await axios.get(ApiServices.pendingProductStock, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message, data } = response.data;
        //  console.log("this is all pending product stock list", data);
        if (status === 200) {
          // const activeproductRow = data.filter(
          //   (product) => product.product_status === "active"
          // );
          // console.log("this is all product stock list", activeproductRow);
          //console.log("Active Product Stock:", activeproductRow);
          // setproductRowList(activeproductRow.slice().reverse());
          setproductRowList(data);
          toast.success(message, { toastId: "product-stock-fetch-success" });
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchproductRowList();
  }, [navigate]);



  // Filter data by name
  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Function to format permission text
  const formatText = (text) => {
    let formattedText = text.replace(/_/g, " ");
    formattedText = formattedText
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
    return formattedText;
  };

  const ExpandableComponent = ({ data }) => {
    const approved = data?.approved ?? null;
    const superApproval = data?.super_approval ?? null;

    // Determine if any buttons should be shown
    const showFirstApproval = approved === 0 || approved === null;
    const showSecondApproval = (superApproval === 0 || superApproval === null) && (approved === 1 || approved === 2);

    // Return null if no buttons should be shown
    if (!showFirstApproval && !showSecondApproval) {
      return null;
    }

    return (
      <div className="flex justify-start px-2 relative">
        {/* Stock Details, Edit, and Additions */}
        {permissions.some(permission => permission.name === 'stock.view') && (
          <div className="relative mx-2 my-2 group">
            <Link
              to="/admin/products/stock/pending/details"
              state={{ stock_id: data.stock_id, productStock: data }}
            >
              <Eye className="w-5 h-5 text-darkGreen3" />

            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
              Details
            </div>
          </div>
        )}
        {/* First Approval Button */}
        {showFirstApproval && (
          <div className="relative mx-2 my-2 group">
            <Link
              to="/admin/product/stock/approval"
              state={{ productRow: data }}

            >
              <CheckCircleFill className="w-5 h-5 text-darkGreen2" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                First Approval
              </div>
            </Link>
          </div>
        )}

        {/* Second Approval Button */}
        {showSecondApproval && (
          <div className="relative mx-2 my-2 group">
            <Link
              to="/admin/product/stock/second/approval"
              state={{ productRow: data }}
            >
              <CheckCircleFill className="w-5 h-5 text-dash4" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                Second Approval
              </div>
            </Link>
          </div>
        )}
      </div>
    );
  };

  const columns = [

    {
      name: "Name",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.name ? row.name.toUpperCase() : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md  text-xs bg-orange1 text-lGrey2">
            {row.sku ? row.sku.toLowerCase() : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Price",
      selector: (row) => CurrencyFormatter(row.price),
      sortable: true,
      width: "180px",
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      sortable: true,
      width: "100px",
    },

    {
      name: "Aval.Qty",
      selector: (row) => row.avail_quantity,
      sortable: true,
      width: "100px",
    },
    {
      name: "Profit",
      selector: (row) => `${row.discount_percentage}%`,
      sortable: true,
      width: "100px",
    },
    {
      name: "Product Owner",
      selector: (row) => (row.product_status ? row.store_id : "NOT AVAILABLE"),
      sortable: true,
      cell: (row) => {
        let backgroundColor = "grey";
        let text = "NOT AVAILABLE";

        if (row.store_id === 1) {
          backgroundColor = "#1D9E34";
          text = "Admin";
        } else if (row.store_id && row.store_id !== 1) {
          backgroundColor = "#4373fc";
          text = "Vendor";
        }

        return (
          <span
            style={{
              backgroundColor: backgroundColor,
              color: "white", // so the text is readable
              padding: "5px 10px",
              borderRadius: "5px",
              display: "inline-block",
            }}
          >
            {text}
          </span>
        );
      },
      width: "180px",
    },

    // {
    //   name: "Product Status",
    //   selector: (row) =>
    //     row.product_status ? row.product_status.toUpperCase() : "NOT AVAILABLE",
    //   sortable: true,
    //   cell: (row) => {
    //     let color = "grey";

    //     if (row.product_status === "active") {
    //       color = "green";
    //     } else if (row.product_status === "inactive") {
    //       color = "red";
    //     }

    //     return (
    //       <span style={{ color: color }}>
    //         {row.product_status
    //           ? row.product_status.toUpperCase()
    //           : "NOT AVAILABLE"}
    //       </span>
    //     );
    //   },
    //   width: "150px",
    // },
    {
      name: "Status",
      selector: (row) =>
        row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        let color = "pending";

        if (row.status === "pending") {
          color = "red";
        }

        return (
          <span style={{ color: color }}>
            {row.status
              ? row.status.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "150px",
    },
    {
      name: "Date",
      selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAIALABLE",
      sortable: true,
      width: "200px",
    },

  ];

  const filteredItems = productRowList.filter((item) => {
    for (let key in item) {
      if (
        typeof item[key] === "string" &&
        item[key].toLowerCase().includes(filterText.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  });

  const data = filteredItems.map((productRow) => ({
    last_restocked_at: productRow.last_restocked_at || "NOT AVAILABLE",
    price: productRow.price || "0.00",
    quantity: productRow.quantity || "0",
    product_category: productRow.product_category || "NOT AVAILABLE",
    sub_category: productRow.sub_category || "NOT AVAILABLE",
    status: productRow.status || "NOT AVAILABLE",
    category: productRow.category
      ? productRow.category.toUpperCase()
      : "NOT AVAILABLE",
    sub_category_id: productRow.sub_category_id,
    category_id: productRow.category_id,
    name: productRow.name,
    product_category_id: productRow.product_category_id,
    product_status: productRow.product_status,
    sku: productRow.sku,
    stock_id: productRow.stock_id,
    store_id: productRow.store_id,
    store_name: productRow.store_name ? productRow.store_name.toUpperCase() : "NOT AVAILABLE",
    product_id: productRow.product_id,
    flash_sale: productRow.flash_sale,
    flash_sale_id: productRow.flash_sale_id,
    quantity: productRow.quantity,
    sold_quantity: productRow.sold_quantity,
    avail_quantity: productRow.avail_quantity,
    discount_percentage: productRow.discount_percentage,
    is_serialized: productRow.is_serialized,
    approved: productRow.approved,
    super_approval: productRow.super_approval,
    created_at: productRow.created_at,
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className=" sm:rounded-lg py-6 w-full">
          <section
            className="w-full pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Pending Stock Product
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>
          <div className="pb-1 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
            <div className="w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md border border-gray-300 rounded-lg"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>

          </div>
          {loading ? (
            <Spinner loading={loading} />
          ) : (

            // <DataTable
            //   columns={columns}
            //   data={sortedData}
            //   pagination
            //   highlightOnHover
            //   striped
            //   customStyles={CustomStyles}
            //   noDataComponent={<div>No Product found</div>}
            //   expandableRows
            //   expandableRowsComponent={ExpandableComponent}
            // />

            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No Product found</div>}
              expandableRows={sortedData.some(item => {
                const approved = item.approved ?? null;
                const superApproval = item.super_approval ?? null;
                const showFirst = approved === 0 || approved === null;
                const showSecond = (superApproval === 0 || superApproval === null) && (approved === 1 || approved === 2);
                return showFirst || showSecond;
              })}
              expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default PendingproductRowList;
